import React, { useEffect, useState, useContext } from 'react';
import './Components.css';
import { Cross2Icon } from '../icons/Icons';
import { useAppStateService } from '../contexts/AppState';

function ProcessTTShotsModal({ProcessResult}){

    const appState = useAppStateService();

    const clickResult = (result) => {
        if(appState.InApp){
            ProcessResult(result);
        }else{
            ProcessResult(false);
        }
    };

    return(
        <div className='modal-container' style={{height:"250px", maxWidth:"550px"}}>
            <button className='modal-close-button' onClick={() => clickResult(false)}><Cross2Icon width='30px' height='30px'/></button>
            <div className='modal-header'>Unprocessed TopTracer Shots Detected</div>
            <div className='modal-content'>
                <div style={{fontSize:'18px'}}>There are unprocessed TopTracer shots in this session.</div>
                <>
                {appState.InApp ? (
                    <div style={{fontSize:'18px'}}>Do you want to process them?</div>
                ) :(
                    <div style={{fontSize:'18px'}}>You must use the application to process them.</div>
                )}
                </>
            </div>
            <div className="modal-footer" >
                <button className="button" style={{width:'100px'}} onClick={() => clickResult(true)}>{appState.InApp ? "Yes" : "Okay"}</button>
            </div>
        </div>
            );
}

export default ProcessTTShotsModal;